import { useEffect, useState } from 'react';
import { TextField, Grid, Box, Typography, Card } from '@mui/material';

import { UrbanTypeServices } from '../../Settings/Subscription/UrbanType/UrbanTypeServices';
import { ProviderServices } from '../CrudServices';

const SubscriptionInfo = (props) => {
    const {providerPersonalDetails} = props;
    const [categoryList, setCategoryList] = useState([]);
      const [urbanTypeList, setUrbanTypeList] = useState([]);
      const fetchUrbanTypeList = async() => {
          try{
              const response = await UrbanTypeServices.fetchValidUrbanTypeList();
              console.log('urban type list fetching response :',response);
    
              if(response.success == '1'){
                  setUrbanTypeList(response.data)
              }else if (response.success == '0'){
                  console.log("error :",response?.message)
              }
          }catch (error){
              console.log("error:",error)
          }
      }
      useEffect(() => {
        const fetchCategoryList = async () => {
          try {
            const categoryListResponse = await ProviderServices.categoryList();
            // console.log("category list Response:",categoryListResponse);
            if (categoryListResponse.success === 1) {
              setCategoryList(categoryListResponse.data)
            }
          } catch (error) {
    
          }
        }
        fetchCategoryList();
        fetchUrbanTypeList();
      }, []);
  return (
    <Grid item xs={12}>
        <Card sx={{}}>
            <Box sx={{ p: '.5%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
                <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Subscription Info</Typography>
            </Box>
            <Grid container spacing={2} sx={{ p: '1%' }}>
                
                <Grid item xs={12} sm={6} >
                    <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Subscription Plan </Typography>
                    {/* <Controller
                        name='subscriptionUrbanTypeId'
                        control={control}
                        rules={{
                            // required: 'please select one urban type'
                        }}
                        render={({field,fieldState:{error}})=>
                            // <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                            //     <Select
                            //         {...field}
                            //         value={field.value || ''}
                            //         error={!!error}
                            //         sx={{
                            //             fontSize:'0.65rem',
                            //         }}
                            //     >    
                            //     {
                            //         urbanTypeList && urbanTypeList.length> 0 && urbanTypeList.map(urban=>(
                            //             <MenuItem key={urban.id} value={urban.id} sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>{urban.typeTitle}</MenuItem>
                            //         ))
                            //     }                                
                            //     </Select>
                            // </FormControl>
                            <Autocomplete
                                fullWidth
                                options={urbanTypeList}
                                getOptionLabel={(option) => option?.typeTitle || ''}
                                isOptionEqualToValue={(option, value) =>
                                    option.id === value?.id || option.id === value
                                }
                                value={urbanTypeList.find(urban => urban.id === field.value) || null}
                                onChange={(event, newValue) => {
                                    let finalValue = newValue?.id || null;
                                    field.onChange(finalValue);
                                }}
                                disableClearable
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        // label="Select SAC Code*"
                                        placeholder='Search and Select Urban Type'
                                        error={!!error}
                                        // helperText={error ? error.message : ''}
                                        size="small"
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { fontSize: '0.75rem' }
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                        {option.typeTitle || ''}
                                    </MenuItem>
                                )}
                            />
                        }
                    /> */}
                    <TextField
                        value={urbanTypeList.find(urban => urban.id == providerPersonalDetails.subscriptionUrbanTypeId)?.typeTitle || ''}
                        size='small'
                        fullWidth
                        disabled
                        inputProps={{
                            style: { fontSize: '.75rem' }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} >
                    <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>Subscription Category</Typography>
                    <Box sx={{display:'flex',alignItems:'center',gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                        <TextField
                            value={categoryList.find(cat => cat.id == providerPersonalDetails.subscriptionCategoryId)?.title || ''}
                            size='small'
                            fullWidth
                            disabled
                            inputProps={{
                                style: { fontSize: '.75rem' }
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Card>
    </Grid>
  )
}

export default SubscriptionInfo
